<template>
    <audio id="audio" loop>
        <source src="@/assets/bgm.mp3" type="audio/mpeg">
    </audio>
</template>

<script>
import { publicAssetUrl } from "@/common/urls";

export default {
    methods: {
        play() {
            const audio = document.getElementById("audio");
            const worldBgmSrc = new URL(publicAssetUrl("assets/world-bgm.mp3"), window.location.origin).href;

            if(this.$route.path === "/world/lobby" && audio.src !== worldBgmSrc) {
                audio.src = worldBgmSrc
            }
            audio.play();
        },
        pause() {
            document.getElementById("audio").pause();
        }
    }
}
</script>
